import React from 'react';
import Card from './Card';
import Button from './Button';

const ThankYouPage = ({ onStartNew }) => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-2xl mx-auto px-4">
        <Card className="text-center">
          {/* Ícone de sucesso */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <svg 
                className="w-10 h-10 text-green-600" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M5 13l4 4L19 7" 
                />
              </svg>
            </div>
          </div>

          {/* Título principal */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Cadastro Realizado com Sucesso!
          </h1>

          {/* Mensagem de agradecimento */}
          <div className="mb-8">
            <p className="text-lg text-gray-600 mb-4">
              Obrigado por se cadastrar em nossa plataforma!
            </p>
            <p className="text-gray-600 mb-6">
              Seus dados foram registrados e nossa equipe irá analisar seu perfil profissional.
            </p>
            
            {/* Destaque da mensagem principal */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6">
              <div className="flex items-center justify-center mb-3">
                <svg 
                  className="w-6 h-6 text-blue-600 mr-2" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
                  />
                </svg>
                <h2 className="text-xl font-semibold text-blue-900">
                  Em breve entraremos em contato!
                </h2>
              </div>
              <p className="text-blue-800">
                Nossa equipe entrará em contato através do telefone ou e-mail informado 
                para dar continuidade ao seu cadastro e apresentar as oportunidades disponíveis.
              </p>
            </div>
          </div>

        </Card>
      </div>
    </div>
  );
};

export default ThankYouPage;
